// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2MA3VX34uStqoeq1NqS7RH"};